import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ModalModule } from 'ngx-bootstrap/modal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UrlSerializer } from '@angular/router';
import { NgbDropdownModule, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavComponent } from './nav/nav.component';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HomeownersComponent } from './homeowners/homeowners.component';
import { RealpropertyComponent } from './homeowners/realproperty/realproperty.component';
import { ChangeaddressComponent } from './homeowners/changeaddress/changeaddress.component';
import { ChangeInOwnershipComponent } from './homeowners/ChangeInOwnership/ChangeInOwnership.component';
import { NewConstructionComponent } from './homeowners/NewConstruction/NewConstruction.component';
import { NewhomeownersComponent } from './homeowners/newhomeowners/newhomeowners.component';
import { HomeownersexemptionComponent } from './homeowners/homeownersexemption/homeownersexemption.component';
import { ContestAssessedValueComponent } from './homeowners/ContestAssessedValue/ContestAssessedValue.component';
import { SupplementaltaxestimatorComponent } from './homeowners/supplementaltaxestimator/supplementaltaxestimator.component';
import { TransferringassessedvalueComponent } from './homeowners/transferringassessedvalue/transferringassessedvalue.component';
import { BusinessownersComponent } from './businessowners/businessowners.component';
import { MarineaircraftComponent } from './businessowners/marineaircraft/marineaircraft.component';
import { LeveltwoComponent } from './leveltwo/leveltwo.component';
import { FormsComponent } from './forms/forms.component';
import { FilterPipe } from './_pipes/filter.pipe';
import { FormFilterPipe } from './_pipes/FormFilter.pipe';
import { ManufacturedhomesComponent } from './businessowners/manufacturedhomes/manufacturedhomes.component';
import { PagetemplateComponent } from './pagetemplate/pagetemplate.component';
import { BusinesspropertystatementComponent } from './businessowners/businesspropertystatement/businesspropertystatement.component';
import { ExemptionsComponent } from './Exemptions/Exemptions.component';
import { TaxreliefComponent } from './taxrelief/taxrelief.component';
import { ExclusionsComponent } from './exclusions/exclusions.component';
import { SolarComponent } from './exclusions/solar/solar.component';
import { BuildersComponent } from './exclusions/builders/builders.component';
import { DisasterreliefComponent } from './taxrelief/disasterrelief/disasterrelief.component';
import { DeclineinvalueComponent } from './taxrelief/declineinvalue/declineinvalue.component';
import { DisabledveteransComponent } from './Exemptions/disabledveterans/disabledveterans.component';
import { TrendfactorsComponent } from './businessowners/trendfactors/trendfactors.component';
import { ContactComponent } from './contact/contact.component';
import { ContactTheAssessorComponent } from './contact/contactTheAssessor/contactTheAssessor.component';
import { GeneralFormComponent } from './contact/contactTheAssessor/generalForm/generalForm.component';
import { ExclusionsFormComponent } from './contact/contactTheAssessor/exclusionsForm/exclusionsForm.component';
import { SpecificFormComponent } from './contact/contactTheAssessor/specificForm/specificForm.component';
import { BusinessFormComponent } from './contact/contactTheAssessor/businessForm/businessForm.component';
import { FileUploadComponent } from './file-upload/file-upload.component';

import { DisabledtransferComponent } from './taxrelief/disabledtransfer/disabledtransfer.component';
import { AduComponent } from './homeowners/adu/adu.component';
import { ProgressComponent } from './file-upload/progress/progress.component';

import { Prop19Component } from './homeowners/prop19/prop19.component';

import { PhoneMaskDirective } from './_directives/phoneMask.directive';
import { AinMaskDirective } from './_directives/ainMask.directive';
import { ContactSpeakerComponent } from './contact/contactSpeaker/contactSpeaker.component';
import { ContactCertificateComponent } from './contact/contactCertificate/contactCertificate.component';
import { OfficeLocationsComponent } from './contact/officeLocations/officeLocations.component';
import { ChurchComponent } from './Exemptions/Church/Church.component';
import { ReligiousComponent } from './Exemptions/Religious/Religious.component';
import { ImportantdatesComponent } from './businessowners/Importantdates/Importantdates.component';

import { AinAddressComponent } from './_shared/ainAddress/ainAddress.component';
import { FindPropertyComponent } from './home/findProperty/findProperty.component';
import { NewsInformationComponent } from './News-Information/News-Information.component';
import { WebinarsPresentationsComponent } from './News-Information/WebinarsPresentations/WebinarsPresentations.component';
import { BusinessStatementFilingComponent } from './businessowners/BusinessStatementFiling/BusinessStatementFiling.component';
import { RegisteredDomesticPartnersComponent } from './exclusions/RegisteredDomesticPartners/RegisteredDomesticPartners.component';
import { PropertySearchComponent } from './homeowners/propertySearch/propertySearch.component';
import { ChatbotComponent } from './home/chatbot/chatbot.component';
import { AboutUsComponent } from './About-us/About-us.component';
import { PropTaxSystemComponent } from './About-us/Prop-tax-system/Prop-tax-system.component';
import { NonProfitComponent } from './Exemptions/Non-Profit/Non-Profit.component';
import { NewslettersComponent } from './News-Information/Newsletters/Newsletters.component';
import { SearchComponent } from './search/search.component';
import { DistrictOfficesComponent } from './contact/district-offices/district-offices.component';
import { WelfareComponent } from './Exemptions/Welfare/Welfare.component';
import { HospitalPropertyComponent } from './Exemptions/HospitalProperty/HospitalProperty.component';
import { MultispecialtyClinicsComponent } from './Exemptions/MultispecialtyClinics/MultispecialtyClinics.component';
import { HousingComponent } from './Exemptions/Housing/Housing.component';
import { AwardsComponent } from './News-Information/Awards/Awards.component';

import { AssessmentRollComponent } from './News-Information/assessmentRoll/assessmentRoll.component';
import { AnnualRollComponent } from './News-Information/annualRoll/annualRoll.component';
import { NewsletterPopupComponent } from './home/newsletter-popup/newsletter-popup.component';
import { FeedbackComponent } from './contact/feedback/feedback.component';
import { PossessoryInterestComponent } from './PossessoryInterest/PossessoryInterest.component';
import { RealEstateFraudComponent } from './RealEstateFraud/RealEstateFraud.component';
import { MeetTheAssessorComponent } from './About-us/meet-the-assessor/meet-the-assessor.component';
import { RealEstateToolkitComponent } from './RealEstateToolkit/RealEstateToolkit.component';
import { DisabledComponent } from './taxrelief/Disabled/Disabled.component';
import { DeathOfAnOwnerComponent } from './homeowners/DeathOfAnOwner/DeathOfAnOwner.component';
import { FactorsPropValueComponent } from './RealEstateToolkit/Factors-Prop-Value/Factors-Prop-Value.component';
import { HowWeCalculateFMVComponent } from './RealEstateFraud/How-We-Calculate-FMV/How-We-Calculate-FMV.component';
import { WelcomeComponent } from './RealEstateToolkit/welcome/welcome.component';
import { Proposition13Component } from './RealEstateToolkit/Proposition13/Proposition13.component';
import { WillsTrustsComponent } from './RealEstateToolkit/WillsTrusts/WillsTrusts.component';
import { ApplyForHOXComponent } from './RealEstateToolkit/ApplyForHOX/ApplyForHOX.component';
import { RefinanceComponent } from './RealEstateToolkit/Refinance/Refinance.component';
import { WhenDoIGetReassessedComponent } from './RealEstateToolkit/WhenDoIGetReassessed/WhenDoIGetReassessed.component';
import { NewsroomComponent } from './News-Information/newsroom/newsroom.component';
import { VeteransComponent } from './Exemptions/Veterans/Veterans.component';
import { InterSpousalComponent } from './exclusions/InterSpousal/InterSpousal.component';
import { JointTenancyComponent } from './exclusions/JointTenancy/JointTenancy.component';
import { EventsComponent } from './RealEstateToolkit/Events/Events.component';
import { DataSalesComponent } from './DataSales/DataSales.component';
import { AlertNotificationComponent } from './_shared/alert-notification/alert-notification.component';
import { SafeHtmlPipe } from './_pipes/safeHtml.pipe';
import { GISsalesComponent } from './DataSales/GISsales/GISsales.component';
import { DataSalesGeneralComponent } from './DataSales/DataSalesGeneral/DataSalesGeneral.component';
import { OnlinePDBComponent } from './DataSales/OnlinePDB/OnlinePDB.component';
import { PriceListComponent } from './DataSales/PriceList/PriceList.component';
import { MillsActComponent } from './taxrelief/MillsAct/MillsAct.component';
import { ChangeOwnershipRescissionComponent } from './taxrelief/ChangeOwnershipRescission/ChangeOwnershipRescission.component';
import { DirectoryComponent } from './contact/directory/directory.component';
import { TaxSavingsFormComponent } from './contact/contactTheAssessor/taxSavingsForm/taxSavingsForm.component';
import { BookingsComponent } from './contact/bookings/bookings.component';
import { BookingsFormComponent } from './contact/bookings/bookings-form/bookings-form.component';
import { BookingsDistrictComponent } from './contact/bookings/bookings-district/bookings-district.component';
import { PublicRecordsComponent } from './News-Information/publicRecords/publicRecords.component';
import { SafePipe } from './_pipes/Safe.pipe';
import { StatusComponent } from './forms/status/status.component';
import { MeetTheStaffComponent } from './About-us/meet-the-staff/meet-the-staff.component';
import { EnotificationComponent } from './News-Information/enotification/enotification.component';
import { ErrorDialogComponent } from '../app/misc/ErrorDialogComponent';
import { FileOnlineV2Component } from './forms/file-online-v2/file-online-v2.component';
import { DynamicControlComponent } from './forms/file-online-v2/components/controls/dynamic-control/dynamic-control.component';
import {FileSizePipe} from './_pipes/fileSize.pipe';
import { FileUploadV2Component } from './forms/file-online-v2/components/controls/file-upload-v2/file-upload-v2.component';
import { RadioLgButtonComponent } from './forms/file-online-v2/components/controls/radio-lg-button/radio-lg-button.component';
import { FormPageSummaryComponent } from './forms/file-online-v2/components/form-page-summary/form-page-summary.component';
import { FormFaqComponent } from './forms/file-online-v2/components/form-faq/form-faq.component';
import { FormTemplateArrayComponent } from './forms/file-online-v2/components/form-template-array/form-template-array.component';
import {FormHelperService} from './forms/file-online-v2/services/form-helper.service';
import {NumberSplitterDirective} from './forms/file-online-v2/directives/number-splitter.directive';
import { DynamicFormLabelComponent } from './forms/file-online-v2/components/controls/dynamic-form-label/dynamic-form-label.component';
import { SsnInputComponent } from './forms/file-online-v2/components/controls/ssn-input/ssn-input.component';
import { AdditionalSignerComponent } from './forms/file-online-v2/components/additional-signer/additional-signer.component';
import { ControlErrorListComponent } from './forms/file-online-v2/components/controls/dynamic-control/control-error-list/control-error-list.component';
import {LowerCaseUrlSerializer} from './serializers/LowerCaseUrlSerializer';
import { ProgressBarComponent } from './forms/file-online-v2/components/progress-bar/progress-bar.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SelectStateComponent } from './forms/file-online-v2/components/controls/select-state/select-state.component';
import {PdfPreviewComponent} from './forms/file-online-v2/components/pdf-preview/pdf-preview.component';
import { LoadingSpinnerComponent } from './forms/file-online-v2/components/loading-spinner/loading-spinner.component';
import { CommaSeparatedPipe } from './_pipes/comma-separated.pipe';
import { FormOutlineComponent } from './forms/file-online-v2/components/form-outline/form-outline.component';
import { AddressSearchComponent } from './forms/file-online-v2/components/address-search/address-search.component';
import {TypeaheadModule} from 'ngx-bootstrap/typeahead';
import { ExistingAddressComponent } from './forms/file-online-v2/components/existing-address/existing-address.component';
import { ButtonResetFieldsComponent } from './forms/file-online-v2/components/controls/button-reset-fields/button-reset-fields.component';
import { Ads820Component } from './contact/ads820/ads820.component';
import { InputLabelComponent } from './contact/ads820/input-label/input-label.component';
import { SimpleErrorListComponent } from './contact/ads820/simple-error-list/simple-error-list.component';
import { AdsControlComponent } from './contact/ads820/ads-control/ads-control.component';
import { ControlGridComponent } from './forms/file-online-v2/components/controls/control-grid/control-grid.component';
import { BannerComponent } from './forms/file-online-v2/components/banner/banner.component';
import {GoogleMapsModule} from '@angular/google-maps';
import { MapSliceComponent } from './_shared/map-slice/map-slice.component';
import { ProgramCardComponent } from './home/programs/program-card/program-card.component';
import { ProgramsComponent } from './home/programs/programs.component';
import {FormListComponent} from './forms/form-list/form-list.component';
import {FormListRowComponent} from './forms/form-list/form-list-row/form-list-row.component';
import {PdfUrlRowComponent} from './_shared/pdf-url-row/pdf-url-row.component';
import {VideosGridComponent} from './_shared/videos-grid/videos-grid.component';
import {
    CertificateAddressComponent
} from './contact/contactCertificate/certificate-address/certificate-address.component';
import {
  PersonalPropertyInputComponent
} from './forms/file-online-v2/components/controls/personal-property-input/personal-property-input.component';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        NavComponent,
        HomeComponent,
        FooterComponent,
        HomeownersComponent,
        RealpropertyComponent,
        ChangeaddressComponent,
        ChangeInOwnershipComponent,
        NewConstructionComponent,
        NewhomeownersComponent,
        HomeownersexemptionComponent,
        ContestAssessedValueComponent,
        LeveltwoComponent,
        FormsComponent,
        FilterPipe,
        FormFilterPipe,
        SafeHtmlPipe,
        SafePipe,
        SupplementaltaxestimatorComponent,
        TransferringassessedvalueComponent,
        BusinessownersComponent,
        MarineaircraftComponent,
        ManufacturedhomesComponent,
        BusinesspropertystatementComponent,
        LeveltwoComponent,
        TrendfactorsComponent,
        PagetemplateComponent,
        PropertySearchComponent,
        ChatbotComponent,
        AssessmentRollComponent,
        AnnualRollComponent,
        NewsletterPopupComponent,
        NewsroomComponent,
        AlertNotificationComponent,
        ExemptionsComponent,
        TaxreliefComponent,
        ExclusionsComponent,
        SolarComponent,
        BuildersComponent,
        DisasterreliefComponent,
        DeclineinvalueComponent,
        DisabledveteransComponent,
        ContactComponent,
        ContactTheAssessorComponent,
        GeneralFormComponent,
        ExclusionsFormComponent,
        SpecificFormComponent,
        BusinessFormComponent,
        FileUploadComponent,
        DisabledtransferComponent,
        AduComponent,
        ExemptionsComponent,
        ProgressComponent,
        Prop19Component,
        PhoneMaskDirective,
        AinMaskDirective,
        ContactSpeakerComponent,
        ContactCertificateComponent,
        OfficeLocationsComponent,
        AinAddressComponent,
        FindPropertyComponent,
        ChurchComponent,
        ReligiousComponent,
        ImportantdatesComponent,
        AinAddressComponent,
        NewsInformationComponent,
        WebinarsPresentationsComponent,
        BusinessStatementFilingComponent,
        RegisteredDomesticPartnersComponent,
        AboutUsComponent,
        PropTaxSystemComponent,
        NonProfitComponent,
        NewslettersComponent,
        SearchComponent,
        DistrictOfficesComponent,
        WelfareComponent,
        HospitalPropertyComponent,
        MultispecialtyClinicsComponent,
        HousingComponent,
        AwardsComponent,
        FeedbackComponent,
        PossessoryInterestComponent,
        RealEstateFraudComponent,
        MeetTheAssessorComponent,
        RealEstateToolkitComponent,
        DisabledComponent,
        DeathOfAnOwnerComponent,
        FactorsPropValueComponent,
        HowWeCalculateFMVComponent,
        WelcomeComponent,
        Proposition13Component,
        WillsTrustsComponent,
        ApplyForHOXComponent,
        RefinanceComponent,
        WhenDoIGetReassessedComponent,
        VeteransComponent,
        InterSpousalComponent,
        JointTenancyComponent,
        EventsComponent,
        DataSalesComponent,
        GISsalesComponent,
        DataSalesGeneralComponent,
        OnlinePDBComponent,
        PriceListComponent,
        MillsActComponent,
        ChangeOwnershipRescissionComponent,
        DirectoryComponent,
        TaxSavingsFormComponent,
        BookingsComponent,
        BookingsFormComponent,
        BookingsDistrictComponent,
        PublicRecordsComponent,
        StatusComponent,
        MeetTheStaffComponent,
        EnotificationComponent,
        ErrorDialogComponent,
        FileOnlineV2Component,
        DynamicControlComponent,
        FileSizePipe,
        FileUploadV2Component,
        RadioLgButtonComponent,
        FormPageSummaryComponent,
        FormFaqComponent,
        FormTemplateArrayComponent,
        NumberSplitterDirective,
        DynamicFormLabelComponent,
        SsnInputComponent,
        AdditionalSignerComponent,
        ControlErrorListComponent,
        ProgressBarComponent,
        SelectStateComponent,
        PdfPreviewComponent,
        LoadingSpinnerComponent,
        CommaSeparatedPipe,
        FormOutlineComponent,
        AddressSearchComponent,
        ExistingAddressComponent,
        ButtonResetFieldsComponent,
        Ads820Component,
        InputLabelComponent,
        SimpleErrorListComponent,
        AdsControlComponent,
        ControlGridComponent,
        BannerComponent,
        MapSliceComponent,
        ProgramCardComponent,
        ProgramsComponent
    ],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ], imports: [BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatIconModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    CollapseModule.forRoot(),
    CarouselModule.forRoot(),
    ProgressbarModule.forRoot(),
    TimepickerModule.forRoot(),
    AlertModule.forRoot(),
    ModalModule.forRoot(),
    FormsModule,
    TabsModule.forRoot(),
    AccordionModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    RecaptchaModule,
    ReactiveFormsModule,
    RecaptchaFormsModule,
    InfiniteScrollModule,
    CurrencyMaskModule,
    NgxSpinnerModule,
    NgbDropdownModule,
    NgbModule,
    PaginationModule,
    PdfViewerModule,
    TypeaheadModule,
    GoogleMapsModule, FormListComponent, FormListRowComponent, PdfUrlRowComponent, VideosGridComponent, CertificateAddressComponent, PersonalPropertyInputComponent],
    exports: [
        SafePipe,
        LoadingSpinnerComponent
    ],
    providers: [
        Title,
        {
            provide: UrlSerializer,
            useClass: LowerCaseUrlSerializer
        },
        FormHelperService,
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())
    ]
})
export class AppModule { }



